var map = {
	"./en/checkout.json": 170,
	"./en/common.json": 6251,
	"./en/contact.json": 4814,
	"./en/diplomados.json": 1474,
	"./en/directorio.json": 3502,
	"./en/faq.json": 2638,
	"./en/footer.json": 6913,
	"./en/home.json": 6953,
	"./en/ia.json": 7336,
	"./en/legal.json": 2883,
	"./en/programs.json": 5251,
	"./en/publicaciones.json": 3835,
	"./en/roxana.json": 4855,
	"./es/checkout.json": 3339,
	"./es/common.json": 3885,
	"./es/contact.json": 9525,
	"./es/diplomados.json": 1715,
	"./es/directorio.json": 3235,
	"./es/faq.json": 2121,
	"./es/footer.json": 1100,
	"./es/home.json": 7316,
	"./es/ia.json": 2781,
	"./es/legal.json": 1324,
	"./es/programs.json": 4026,
	"./es/publicaciones.json": 4100,
	"./es/roxana.json": 2918,
	"./pt-br/checkout.json": 6258,
	"./pt-br/common.json": 8355,
	"./pt-br/contact.json": 4598,
	"./pt-br/diplomados.json": 778,
	"./pt-br/directorio.json": 7366,
	"./pt-br/faq.json": 9238,
	"./pt-br/footer.json": 1161,
	"./pt-br/home.json": 3457,
	"./pt-br/ia.json": 5216,
	"./pt-br/legal.json": 9883,
	"./pt-br/programs.json": 4619,
	"./pt-br/publicaciones.json": 5891,
	"./pt-br/roxana.json": 5535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6266;